import ButtonLoader from "@components/loaders/ButtonLoader";
import type { MouseEvent, ReactNode } from "react";

type ActionVariant = "primary" | "success" | "danger" | "neutral";

const VARIANT_CLASSES: Record<ActionVariant, string> = {
  primary:
    "border-[#D5E0F7] bg-[#FFFFFF] text-[#1D4ED8] hover:border-[#9BB6F0] hover:bg-[#F4F7FF]",
  success:
    "border-[#D3EDDC] bg-[#FFFFFF] text-[#2F7D4A] hover:border-[#8FCBAA] hover:bg-[#F3FBF6]",
  danger:
    "border-[#F3D0D0] bg-[#FFFFFF] text-[#B42318] hover:border-[#E7A3A3] hover:bg-[#FFF6F6]",
  neutral:
    "border-[#E4E7EC] bg-[#FFFFFF] text-[#3A4158] hover:border-[#C9D0DA] hover:bg-[#F7F8FA]",
};

export default function TableActionButton({
  children,
  onClick,
  variant = "neutral",
  icon,
  disabled = false,
  loading = false,
  title,
}: {
  children: ReactNode;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  variant?: ActionVariant;
  icon?: string;
  disabled?: boolean;
  loading?: boolean;
  title?: string;
}) {
  return (
    <button
      type="button"
      title={title}
      disabled={disabled || loading}
      onClick={onClick}
      className={`inline-flex h-7 items-center justify-center gap-1 whitespace-nowrap rounded-md border px-2 text-[11px] font-semibold tracking-[-0.01em] shadow-[0_1px_1px_rgba(21,24,44,0.04)] transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#81d1f4]/60 active:translate-y-px active:shadow-none disabled:cursor-not-allowed disabled:opacity-50 ${VARIANT_CLASSES[variant]}`}
    >
      {loading ? (
        <ButtonLoader />
      ) : (
        <>
          {icon && (
            <span
              className="material-symbols-outlined leading-none"
              style={{
                fontSize: 14,
                fontVariationSettings:
                  "'FILL' 0, 'wght' 500, 'GRAD' 0, 'opsz' 20",
              }}
            >
              {icon}
            </span>
          )}
          {children}
        </>
      )}
    </button>
  );
}
